// Shape of Route data for list of routes in the route panel.

import { RouteEditMode } from '../state/routeState';
import { RouteStop, EtaEtdDateTime } from './routeStop';
import { DayOfWeek } from 'src/app/utils/dayOfWeek';
import { DateTime } from 'luxon';
import { optionsUI } from 'src/app/utils/optionsUI';

export interface RouteTotals {
  cost?: string;
  tolls?: string;
  distance?: string;
  time?: string;
}

export interface ArrDepSelection {
  type?: string; // 'None' | 'Arrive' | 'Depart' | 'Now';
  datetype?: string; // 'date' | 'weekday';
  useTraffic?: boolean;
  weekday?: string; // 'monday'
  date?: string;
  time?: string;
}
export interface Route {
  historicalDataVersion: string;
  id: number;
  name?: string;
  color?: string;
  isSelected?: boolean;
  isOpen?: boolean;
  arrDepSelection?: ArrDepSelection;
  isVisibleOnMap: boolean;
  isAcceptLegacy?: boolean;
  isLegacy?: boolean;
  editMode: RouteEditMode;

  stops: RouteStop[];

  totals?: RouteTotals;
  profileId?: number;
  savedId?: number;
  profileDeleted?: boolean;
  optionSummary?: string; // Route options summary display
  tripProfileId?: number; //while Saving Route we are not passing profileID, dataAnyWhere service will create a profileID for every newly saved route.
}
export interface StopTimeStamp {
  routeId: number; // route id
  time: number; // time in milliseconds when a stop is added to a given route
}

export function getEtaEtdDateTime(etaEtd: string): EtaEtdDateTime {
  let ee = null;
  if (typeof etaEtd !== 'undefined' && etaEtd !== null) {
    const eeItems = etaEtd.split(' '); // 3/4/2023 3:11 AM
    const eeDate = eeItems[0];
    const eeDateParts = eeDate.split('/');
    ee = {
      date: `${eeDateParts[0]}/${eeDateParts[1]}`, // 3/4
      time: `${eeItems[1]} ${eeItems[2]}`, // 3:11 AM
    };
  }
  return ee;
}

export function deserializeArrDepSelection(
  estimatedTimeOpts: string
): ArrDepSelection {
  let arrDepSelection: ArrDepSelection = null;
  if (typeof estimatedTimeOpts !== 'undefined' && estimatedTimeOpts !== null) {
    const etParts = estimatedTimeOpts.split('|');
    arrDepSelection = {};
    if (etParts.length === 1 && etParts[0] === optionsUI.arrDepTypes[2].value) {
      arrDepSelection.type = optionsUI.arrDepTypes[1].value;
    }
    if (
      etParts[0] === optionsUI.arrDepTypes[3].value ||
      etParts[0] === optionsUI.arrDepTypes[2].value
    ) {
      // arrive or depart
      arrDepSelection.type = etParts[0];
      if (etParts.length > 1) {
        const dayOfWeek = etParts[1] || ''; // MONDAY etc.;
        const index = DayOfWeek.findIndex(
          (d) => d.key === dayOfWeek.toUpperCase()
        );
        if (index > -1) {
          arrDepSelection.datetype = optionsUI.daydatetype[0].value;
          if (etParts.length > 2) {
            arrDepSelection.weekday = dayOfWeek.toLowerCase();
            arrDepSelection.time = etParts[3]; // not tested
          }
        } else {
          arrDepSelection.datetype = optionsUI.daydatetype[1].value;
          const dt = DateTime.fromISO(etParts[1]); // 2014-03-04T18:15:30-05:00
          arrDepSelection.date = dt.toLocaleString(DateTime.DATE_SHORT); // 3/4/2014
          arrDepSelection.time = dt.toLocaleString(DateTime.TIME_SIMPLE); //  6:15 PM
        }
      }
    }
  }
  return arrDepSelection;
}

export function serializeArrDepSelection(data: ArrDepSelection): string {
  const dtm = `${data.date}, ${data.time}`;
  const dt = DateTime.fromFormat(dtm, 'f');
  let arrDepString = null;
  if (data.type !== optionsUI.arrDepTypes[0].value) {
    if (data.type === optionsUI.arrDepTypes[1].value) {
      arrDepString = optionsUI.arrDepTypes[2].value;
      // SWPWEB-1220; do not add timestamp if date.type = now
    } else {
      arrDepString = data.type;
      if (data.datetype === optionsUI.daydatetype[1].value) {
        arrDepString += `|${dt.toISO()}`;
      } else if (data.datetype === optionsUI.daydatetype[0].value) {
        const time = dt.toLocaleString(DateTime.TIME_SIMPLE); // 6:00 AM // not tested
        arrDepString += `|${data.weekday}|${time}`;
      }
    }
  }
  // Empty -> None
  // Depart -> Now
  // [Arrive, Depart]|2014-03-04T08:15:30-05:00 -> date time
  // [Arrive, Depart]|weekday|HH:mm -> weekday time
  return arrDepString;
}
